import { Text as MantineText } from '@mantine/core'

import { TEXT_VARIANT_BODY } from '@/components/Text/Text.constants'
import type { TextProps } from '@/components/Text/Text.types'

export function Text({ variant = 'body_1', ...props }: TextProps) {
  const variantConfig = TEXT_VARIANT_BODY[variant]

  return <MantineText {...props} {...variantConfig} />
}
